import { Grid } from "@mui/material";
import { City, Professional, Team } from "@syadem/ariane-js";
import { CitySearchField } from "./shared/CitySearchField";
import { ProfessionalSearchField } from "./shared/ProfessionalSearchField";

export function CityAndProAutocomplete({
  city,
  cityError,
  onCityChange,
  professional,
  professionalError,
  onProfessionalChange,
  onArianeError,
}: {
  city?: City;
  cityError?: boolean;
  onCityChange: (city?: City) => void;
  professional?: Professional | Team;
  professionalError?: boolean;
  onProfessionalChange: (professional?: Professional | Team) => void;
  onArianeError?: (error: unknown) => void;
}) {
  return (
    <>
      <Grid size={{ xs: 12, md: 6 }}>
        <CitySearchField
          city={city}
          onCityChange={onCityChange}
          splitZipCode
          onProfessionalChange={onProfessionalChange}
          professional={professional}
          cityError={cityError}
          onArianeError={onArianeError}
          required
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <ProfessionalSearchField
          city={city}
          professional={professional}
          professionalError={professionalError}
          onProfessionalChange={onProfessionalChange}
          onArianeError={onArianeError}
        />
      </Grid>
    </>
  );
}
